import { useRef, useEffect, useState } from "react";
import { Responsive as RGLResponsive } from "react-grid-layout";

/** Drop-in replacement for the removed WidthProvider(Responsive) pattern. */
export default function ResponsiveGrid({ children, ...rest }) {
  const ref = useRef(null);
  const [width, setWidth] = useState(1000);

  useEffect(() => {
    if (!ref.current) return;
    const el = ref.current;
    const ro = new ResizeObserver(() => {
      setWidth(el.getBoundingClientRect().width);
    });
    ro.observe(el);
    setWidth(el.getBoundingClientRect().width);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ width: "100%" }}>
      <RGLResponsive width={width} {...rest}>
        {children}
      </RGLResponsive>
    </div>
  );
}
